<template lang="pug">
  label.v-shipping-method.u-block(
  :class="{selected: isSelected, disabled: isUndeliverable}",
  ref="shipping-method-label"
  )
    .u-flex.u-flex-ai-center
      .form__radio(v-if="isSelectable")
        input.form-ctl(
        type="radio",
        :name="'shipping_charge_' + shipment._id",
        :value="shippingCharge.shipping_method",
        :checked="isSelected",
        :disabled="isUndeliverable",
        @change="$emit('change', shippingCharge.shipping_method)"
        )
        span.label

      div(v-if="displayDetails")
        // 配送方法
        span {{getShippingMethodLabel(shippingCharge.shipping_method)}}

        // 料金
        p.p-price
          span.p-price__regular.u-inline-block.u-mrxs(v-if="shippingCharge.actual > shippingCharge.billing") {{shippingCharge.actual | currency}}
          strong.p-price__price.u-fs-md.u-inline-block {{shippingCharge.billing | currency}}

          // TOMプレミアム会員向け
          span.u-inline-block.u-mlxs(v-if="shippingCharge.is_applied_config_for_premium")
            img.c-tom-premium--inline.u-valign-text-bottom.u-ml0.u-mr0(:src="'/images/tom_premium_h.svg' | staticImageUrl", alt="TOM Premium", style="width: 97px; height: 15px;")

          // TOMポイント
          span.p-price__point-back.u-fs-sm.u-inline-block.u-mlxs(v-if="shippingCharge.point_back > 0")
            | and get
            strong.p-point__earn-point.u-mlxs.u-mrxs {{shippingCharge.point_back | currency}}
            | points back!

          // 閉じるボタン
          button.v-discount__btn.c-btn--link.u-mlxs(@click.prevent.stop="toggleDisplayDetails")
            i.icon-angle-down.u-mrxs
            | see details

        // 割引についての詳細（コンテンツ）
        .v-discount(v-if="shippingCharge.actual > shippingCharge.billing")
          .v-discount__contents.u-flex.u-flex-ai-end.u-mtxs.u-mbxs
            .u-align-center
              .v-discount__contents__label.u-fs-sm Shipping fee
              .u-fs-md {{shippingCharge.actual | currency}}
            .u-mls
              .u-fs-md -
            .u-align-center.u-mls
              .v-discount__contents__label.u-fs-sm TOM Pays
              .u-fs-md {{shippingCharge.discount | currency}}
            .u-mls
              .u-fs-md =
            .u-align-center.u-mls
              .v-discount__contents__label.u-fs-sm You Pay
              .p-price__price.u-fs-md {{shippingCharge.billing | currency}}

        // 配送期間
        .u-fs-sm
          | Delivered in approx.
          span.u-mlxs {{shippingCharge.average_delivery_time}}

        // SPRの注意文を表示
        .c-message.c-message--warn.c-message--sm.u-mts.u-mb0(v-if="isDisplaySPRMessage")
          .c-message__body
            span For all SPR shipping methods, local tracking updates may not show up fully due to local postal service operations in your country. You may need to visit your nearest post office to check for updates.

        // BULK_SHIPPING_UPSGの注意文を表示
        .c-message.c-message--warn.c-message--sm.u-mts.u-mb0(v-if="isDisplayBulkShippingUPSGMessage")
          .c-message__body
            span.
              We reserve TOM-only shipping containers to ensure your package has the safest possible voyage from Japan to the US. Once your package reaches the US, you’ll receive tracking information and it will be delivered via UPS Ground.#[br]
              #[a(href="https://otakumode.com/hc/shop/shipping_and_delivery/shipping_methods/61f744263276630039e220cb" target="_blank") More info here].

        // CA向けFEDEXの注意文を表示
        .c-message.c-message--warn.c-message--sm.u-mts.u-mb0(v-if="isDisplayCanadaFedexMessage")
          .c-message__body
            span Payment of additional customs fees may be required before delivery. FedEx will contact you if this is the case. Customs fees are NOT included in your Grand Total.

      div(v-else)
        // 配送方法
        span
          | {{getShippingMethodShortLabel(shippingCharge.shipping_method)}}: {{shippingCharge.billing | currency}} ({{getShortAverageDeliveryTime(shippingCharge.shipping_method)}})

          // 開くボタン
          button.v-discount__btn.c-btn--link.u-mlxs(v-if="hasDetail", @click.prevent.stop="toggleDisplayDetails")
            i.icon-angle-right.u-mrxs
            | see details

    template(v-if="shouldDisplaySuspendedShippingNotice")
      .c-message.c-message--warn.u-mts(v-if="Shipments.hasPreOrderSku(shipment)")
        | This shipping method is currently suspended. If it hasn't resumed by the time your order is stocked, you can switch to another method. Additional costs may apply.
        |
        a.link--inherit.u-valign-middle(href="https://otakumode.com/hc/shop/shipping_and_delivery/shipping_and_delivery_general/58758eb7a4e6f5b771940a90", target="_blank"): i.icon-question-sign
      .c-message.c-message--warn.u-mts(v-else-if="Shipments.hasInStockSku([shipment]) || Shipments.hasBtoSku(shipment)")
        | This shipping method is currently suspended. If you wish, you can switch to another method after purchasing. Additional costs may apply.
        |
        a.link--inherit.u-valign-middle(href="https://otakumode.com/hc/shop/shipping_and_delivery/shipping_and_delivery_general/58758eb7a4e6f5b771940a90", target="_blank"): i.icon-question-sign
</template>

<script>
import urlUtil from '../../util/url';
import textUtil from '../../util/text';

import { SHIPPING_METHODS } from '../../../../../../lib/document/schema/shipping_method';
import Shipments from '../../stores/schema/injected/Shipments';

export default {
  name: 'shipping_method',

  model: {
    prop: 'selectedShippingMethod',
    event: 'change'
  },

  data() {
    return {
      displayDetails: false
    };
  },

  props: {
    selectedShippingMethod: {
      type: String,
      required: true
    },

    currentShippingCountry: {
      type: String,
      required: true
    },

    shipment: {
      type: Object,
      required: true
    },

    shippingCharge: {
      type: Object,
      required: true
    },

    loading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    shippingCharges() {
      return this.shipment.shipping_charges;
    },

    isSelected() {
      // MEMO:
      // `/cart/shipping_method`からエラーが返ってきた場合に、ラベルの選択状態は正しくロールバックされるが
      // inputの状態が正しくロールバックされないので、`loading`の状態も監視している
      // （なぜこれでinputの状態が正しくロールバックされるかは分からない）
      return this.shippingCharge.selected && !this.loading;
    },

    isSelectable() {
      return this.shipment.shipping_charges.length > 1;
    },

    isUndeliverable() {
      return this.shipment.undeliverable;
    },

    isDisplaySPRMessage() {
      if (!['CA', 'AU'].includes(this.currentShippingCountry)) {
        return false;
      }
      const method = this.getShippingMethod(
        this.shippingCharge.shipping_method
      );
      return [SHIPPING_METHODS.AIR_SPR, SHIPPING_METHODS.SAL_SPR].some(
        (spr) => spr.value === method.value
      );
    },

    isDisplayBulkShippingUPSGMessage() {
      return (
        this.getShippingMethod(this.shippingCharge.shipping_method).value ===
        SHIPPING_METHODS.BULK_SHIPPING_UPSG.value
      );
    },

    isDisplayCanadaFedexMessage() {
      return (
        this.currentShippingCountry === 'CA' &&
        [
          SHIPPING_METHODS.FEDEX_PRIORITY.value,
          SHIPPING_METHODS.FEDEX_ICP.value
        ].includes(
          this.getShippingMethod(this.shippingCharge.shipping_method).value
        )
      );
    },

    hasDetail() {
      return (
        this.shippingCharge.actual > this.shippingCharge.billing ||
        this.shippingCharge.is_applied_config_for_premium ||
        this.shippingCharge.point_back > 0 ||
        this.shippingCharge.actual > this.shippingCharge.billing ||
        this.isDisplaySPRMessage ||
        this.isDisplayBulkShippingUPSGMessage ||
        this.isDisplayCanadaFedexMessage
      );
    },

    shouldDisplaySuspendedShippingNotice() {
      return (
        this.isSelected &&
        this.currentShippingCountry === 'US' &&
        [
          SHIPPING_METHODS.EMS.value,
          SHIPPING_METHODS.EPACKET_LIGHT.value,
          SHIPPING_METHODS.SURFACE_PARCEL.value
        ].includes(
          this.getShippingMethod(this.shippingCharge.shipping_method).value
        )
      );
    },

    Shipments() {
      return Shipments;
    }
  },

  watch: {
    isSelected(isChecked) {
      if (isChecked) {
        this.$refs['shipping-method-label'].focus();
      }
    }
  },

  filters: {
    currency: textUtil.currency,
    staticImageUrl: urlUtil.staticImageUrl
  },

  methods: {
    toggleDisplayDetails() {
      this.displayDetails = !this.displayDetails;
    },

    getShippingMethod(key) {
      return (
        SHIPPING_METHODS[key] ||
        // `Air_SPR`や`Newgistics_5`のようにキー名に小文字が入っているケースをケア
        Object.values(SHIPPING_METHODS).find((shippingMethod) => {
          return shippingMethod.value === key;
        })
      );
    },

    getShippingMethodLabel(key) {
      const method = this.getShippingMethod(key);
      return this.getShippingMethodCustomLabel(method.value, method.label);
    },

    getShippingMethodShortLabel(key) {
      const method = this.getShippingMethod(key);
      if (method.short_label) {
        return this.getShippingMethodCustomLabel(
          method.value,
          method.short_label
        );
      }
      return this.getShippingMethodCustomLabel(method.value, method.label);
    },

    getShippingMethodCustomLabel(value, label) {
      const plane = [
        'EMS',
        'Air Parcel',
        'Air_SPR',
        'EPACKET_LIGHT',
        'FEDEX_PRIORITY',
        'FEDEX_ICP',
        'FEDEX_ICP_DDP',
        'DHL_EXPRESS',
        'ECMS'
      ];
      const ship = ['Surface Parcel', 'BULK_SHIPPING_UPSG'];

      if (plane.includes(value)) {
        return '✈️ ' + label;
      }
      if (ship.includes(value)) {
        return '🚢 ' + label;
      }
      return label;
    },

    getShortAverageDeliveryTime(key) {
      const method = this.getShippingMethod(key);
      return method.short_average_delivery_time || method.average_delivery_time;
    },

    getShippingChargesNotIncludeFSS() {
      return this.shippingCharges.filter((shippingCharges) => {
        return shippingCharges.billing !== 0;
      });
    }
  }
};
</script>

<style scoped>
.v-shipping-method {
  font-weight: normal;
  margin-bottom: 0;
  padding: 10px;
}

.v-shipping-method.selected {
  background: #d5e9f4;
}

.v-shipping-method.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.v-discount__btn {
  outline: 0;
  padding: 0;
}

.v-discount__contents {
  background: #fafafa;
  padding: 10px;
}

.v-discount__contents__label {
  color: #808080;
}
</style>
